import { Building2Icon } from 'lucide-react'

import { Card, CardContent } from '@/components/card/card'

import { cn } from '@/lib/utils'

export interface CompanyInfoCardProps {
  companyLogo?: string
  companyName?: string
}

export const CompanyInfoCard = ({ companyLogo, companyName }: CompanyInfoCardProps) => {
  return (
    <Card>
      <CardContent className={cn('p-6')}>
        <p className={cn('flex items-center gap-x-2', 'text-[16px] font-semibold leading-[16px] text-foreground')}>
          <Building2Icon size={16} />
          Company Information
        </p>
        <div className={cn('flex items-center gap-x-4', 'mt-8')}>
          {companyLogo ? (
            <img className={cn('w-10', 'h-10', 'rounded-[50%]')} src={companyLogo} />
          ) : (
            <div className={cn('flex items-center justify-center', 'rounded-[50%]', 'w-10', 'h-10', 'bg-slate-200')} />
          )}
          <p className={cn('text-base font-medium text-black')}>{companyName}</p>
        </div>
      </CardContent>
    </Card>
  )
}
